<template>
  <div v-if="orderedSurveys.length > 0">
    <div class="admin__header">
      <h1 class="no-margin">Surveys</h1>

      <div class="admin__header-actions">
        <label class="actions actions--no-block">
          Show Archived Surveys?
          <div class="input input--checkbox input--spacing">
            <input
              type="checkbox"
              class="input__default"
              :checked="showArchivedSurveys"
              @change="setShowArchivedSurveys($event.target.checked)">
            <div class="input__styled input__styled--checkbox" :class="{'is-checked': showArchivedSurveys}"></div>
          </div>
        </label>
        <router-link :to="{ name: 'admin-new-survey' }" class="button no-margin">Add Survey</router-link>
      </div>
    </div>

    <div class="list-view">
      <div class="list-view__header">
        <div>Title</div>
        <div class="list-view__small-column">Published</div>
        <div class="list-view__small-column">Last Updated</div>
        <div class="list-view__small-column">Responses</div>
        <div class="list-view__small-column">Actions</div>
      </div>

      <div class="list-view__row" v-for="survey in orderedSurveys">
        <div><router-link :to="{ name: 'admin-show-survey', params: { surveyId: survey.id } }">{{ survey.title }}</router-link><template v-if="survey.archived">&nbsp;<small>(archived)</small></template></div>
        <div class="list-view__small-column"><span class="show-for-small">Published:&nbsp;</span><i class="material-icons status-green" v-if="survey.published">check</i><i class="material-icons status-red" v-else>clear</i></div>
        <div class="list-view__small-column" :title="formatDateLong(survey.updated_at)"><span class="show-for-small">Last Updated:&nbsp;</span>{{ formatDate(survey.updated_at) }}</div>
        <div class="list-view__small-column"><span class="show-for-small">Responses:&nbsp;</span>{{ survey.response_count || 0 }}</div>
        <div class="list-view__small-column">
          <router-link :to="{ name: 'admin-edit-survey', params: { surveyId: survey.id } }"><i class="material-icons">mode_edit</i></router-link>
          <button class="icon-button" @click="archiveSurvey(survey)" :disabled="survey.archived"><i class="material-icons">archive</i></button>
          <button class="icon-button" @click="cloneSurvey(survey)" :disabled="!!survey.cloning">
            <i class="material-icons" title="Clone survey">content_copy</i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <no-items v-else
    name="Survey"
    icon="work"
    new-link="admin-new-survey"
  ></no-items>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  import NoItems from '@/components/admin/NoItems';
  import DateFormatter from '@/mixins/date';

  export default {
    name: 'admin-surveys',

    mixins: [DateFormatter],

    components: {
      'no-items': NoItems,
    },

    computed: {
      ...mapState('admin', {
        showArchivedSurveys: state => state.survey.showArchivedSurveys,
      }),

      ...mapGetters('admin', [
        'orderedSurveys',
      ]),
    },

    methods: {
      ...mapMutations('admin', [
        'setShowArchivedSurveys',
      ]),

      ...mapActions('admin', [
        'fetchSurveys',
      ]),

      archiveSurvey(survey) {
        /* eslint-disable no-alert */
        if (confirm(
          `Are you sure you want to archive ${survey.title}? No more responses to the survey will be accepted.`)) {
          this.$store.dispatch('admin/archiveSurvey', { surveyId: survey.id });
        }
      },

      cloneSurvey(survey) {
        // eslint-disable-next-line no-alert
        const clonedTitle = prompt('Cloned survey name:', `${survey.title} (cloned)`);
        if (clonedTitle) {
          this.$store.dispatch('admin/cloneSurvey', {
            surveyId: survey.id,
            clonedTitle,
          });
        }
      },
    },

    created() {
      this.fetchSurveys();
    },
  };
</script>
